import { render, staticRenderFns } from "./PaymentCarrierListTop.vue?vue&type=template&id=2fefa677&scoped=true&"
import script from "./PaymentCarrierListTop.vue?vue&type=script&lang=js&"
export * from "./PaymentCarrierListTop.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCarrierListTop.vue?vue&type=style&index=0&id=2fefa677&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fefa677",
  null
  
)

export default component.exports